module.exports = __webpack_public_path__ + "static/media/08.4b43b25e.png";